import React, { useState } from 'react';
import { useAppSelector } from '../../store/store';
import { getBrandCampaigns, getDefaultCampaigns } from '../../store/selector/campaign.selector';
import { useNavigate } from 'react-router-dom';
import DashboardCampaignPlan from './DashboardCampaignPlan';
import DashboardNewCampaignPlan from './DashboardNewCampaignPlan';

const DashboardCampaignPlans = () => {
    const navigate = useNavigate();
    const defaultCampaigns = useAppSelector(getDefaultCampaigns);
    const brandCampaigns = useAppSelector(getBrandCampaigns);

    const [selectingPlanId, setSelectingPlanId] = useState<string | null>(null);

    const handleSeeMoreClick = (suggested: boolean) => {
        if (suggested) {
            navigate('/plans?suggested=true');
        } else navigate('/plans');
    };

    return (
        <div className="tw-w-full tw-max-w-md xl:tw-max-w-5xl tw-flex tw-flex-col tw-gap-y-10">
            {brandCampaigns.length > 0 && (
                <div>
                    <div className="tw-w-full tw-flex tw-items-center tw-justify-between tw-mb-4">
                        <span className="tw-font-medium">Your Plans</span>
                        <div
                            className="tw-cursor-pointer tw-text-sm tw-underline tw-text-purple-100"
                            onClick={() => handleSeeMoreClick(false)}
                        >
                            See more
                        </div>
                    </div>
                    <div className="tw-w-full tw-grid tw-grid-cols-1 xl:tw-grid-cols-3 tw-gap-4">
                        <DashboardNewCampaignPlan
                            selectingPlanId={selectingPlanId}
                            setSelectingPlanId={setSelectingPlanId}
                        />
                        {brandCampaigns.slice(0, 2).map((campaign) => (
                            <DashboardCampaignPlan
                                key={campaign.id}
                                campaign={campaign}
                                selectingPlanId={selectingPlanId}
                                setSelectingPlanId={setSelectingPlanId}
                            />
                        ))}
                    </div>
                </div>
            )}

            {defaultCampaigns.length > 0 && (
                <div>
                    <div className="tw-w-full tw-flex tw-items-center tw-justify-between tw-mb-4">
                        <span className="tw-font-medium">Plans Suggested For You</span>
                        <div
                            className="tw-cursor-pointer tw-text-sm tw-underline tw-text-purple-100"
                            onClick={() => handleSeeMoreClick(true)}
                        >
                            See more
                        </div>
                    </div>
                    <div className="tw-w-full tw-grid tw-grid-cols-1 xl:tw-grid-cols-3 tw-gap-4">
                        {defaultCampaigns.slice(0, 9).map((campaign) => (
                            <DashboardCampaignPlan
                                key={campaign.id}
                                campaign={campaign}
                                selectingPlanId={selectingPlanId}
                                setSelectingPlanId={setSelectingPlanId}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardCampaignPlans;
